<template>
  <div class="data-table-editable-th">
    <div v-if="!isEditing" class="d-flex align-center">
      <div class="th text-ordinary">{{ title }}</div>

      <e-tooltip v-if="!disabled">
        <template #activator>
          <e-icon class="ml-1 link" name="editPen" :size="16" @click="startEdit" />
        </template>
        <span class="paragraph-xs text-secondary"> Редактировать выбранные </span>
      </e-tooltip>
    </div>
    <slot v-else />
  </div>
</template>

<script setup lang="ts">
import { useEventListener } from '@vueuse/core';
import { ref } from 'vue';
import { EIcon, ETooltip } from '@/core/components/ui';

defineProps<{
  title: string;
  disabled?: boolean;
}>();

defineSlots<{
  default: () => void;
}>();

const emit = defineEmits<{
  (event: 'start'): void;
  (event: 'end'): void;
}>();

const isEditing = ref(false);

let stop: (() => void) | undefined;

const stopEdit = () => {
  if (!isEditing.value) {
    return;
  }
  if (stop) {
    stop();
    stop = undefined;
  }

  isEditing.value = false;

  emit('end');
};

const startEdit = () => {
  isEditing.value = true;

  stop = useEventListener('keydown', (e) => {
    if (e.code === 'Escape') {
      stopEdit();
    }
  });

  emit('start');
};

defineExpose({
  stopEdit,
});
</script>

<style scoped lang="scss">
.data-table-editable-th {
  display: flex;
  align-items: center;

  @include ellipsis();

  overflow: visible;
}
</style>
